import React from 'react';
import { Heart, Check, X, PawPrint } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { fitYes, fitNo } from '../../data/content';
export function FitSection() {
  return <section className="bg-white py-16 md:py-[84px]" data-id="element-43" data-mp="2uyosp8x0mk63">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-44" data-mp="2z0a1oj6fieb0">
        <SectionHeading kicker="¿Esto es para mí?" icon={Heart} title={<>
              Sé honesto/a: <em data-id="element-46" data-mp="2pzu39o4jlxd0">¿es para ti?</em>
            </>} lead="Preferimos que lo compres solo si te va a servir." data-id="element-45" data-mp="2yyz26vk0nspp" />
        <div className="mt-11 grid gap-[22px] md:grid-cols-2" data-id="element-47" data-mp="2c1nnpo3gok25">
          <Reveal className="rounded-[26px] bg-forest px-6 py-7 text-cream md:px-[30px] md:py-[34px]" data-id="element-48" data-mp="2g1nzt2338j61">
            <h3 className="mb-5 flex items-center gap-3 text-2xl font-bold text-tangerine-light" data-id="element-49" data-mp="a8fxvkq82k20">
              <Check className="h-7 w-7" strokeWidth={3} aria-hidden="true" data-id="element-50" data-mp="eb2udyxu8t5j" />
              Es para ti si…
            </h3>
            <ul className="flex flex-col gap-3.5" data-id="element-51" data-mp="izog6cbpkbov">
              {fitYes.map(t => <li key={t} className="flex items-start gap-3 text-[16.5px]" data-id="element-52" data-mp="e2eriyw58423">
                  <PawPrint className="mt-[3px] h-5 w-5 shrink-0 text-tangerine-light" fill="currentColor" aria-hidden="true" data-id="element-53" data-mp="sq9l0hhz6cg8" />
                  {t}
                </li>)}
            </ul>
          </Reveal>
          <Reveal className="rounded-[26px] border-2 border-line bg-white px-6 py-7 md:px-[30px] md:py-[34px]" data-id="element-54" data-mp="12eowca4ikf">
            <h3 className="mb-5 flex items-center gap-3 text-2xl font-bold text-danger" data-id="element-55" data-mp="3r983eejy3pjj">
              <X className="h-7 w-7" strokeWidth={3} aria-hidden="true" data-id="element-56" data-mp="a12zyntpl8r9" />
              No es para ti si…
            </h3>
            <ul className="flex flex-col gap-3.5" data-id="element-57" data-mp="4zdnr4ur2p1l">
              {fitNo.map(t => <li key={t} className="flex items-start gap-3 text-[16.5px] text-muted" data-id="element-58" data-mp="1ldvo7onajf2k">
                  <X className="mt-[3px] h-[18px] w-[18px] shrink-0 text-[#B5A58C]" strokeWidth={2.6} aria-hidden="true" data-id="element-59" data-mp="1gf2b3xbx1q2x" />
                  {t}
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}